(<template>
  <section>
    <div ref="paymentMethodRef"
         :class="{'is-with-error': paymentMethodErrors.length}"
         class="buyer-info__item post-form__section payment-method">
      <template v-if="paymentMethodsList.length <= 6">
        <ul class="payment-method__list"
            @focusin="openPaymentMethodHelper">
          <li v-for="payment in paymentMethodsListCard"
              :key="payment.id"
              :class="payment.id === paymentMethod ? 'payment-method__item--active': ''"
              class="payment-method__item"
              tabindex="0"
              @click="handleChangeMethod(payment.id)">
            <template v-if="isOrganizationalMethod(payment)">
              <h3 class="payment-method__name">{{ payment.orgName }}</h3>
              <p class="payment-method__number">Org.: {{ payment.orgNumber }}</p>
            </template>
            <template v-else>
              <h3 class="payment-method__email">{{ payment.email }}</h3>
              <p class="payment-method__address">Add: {{ fullAddress(payment.address) }}</p>
            </template>
            <span v-if="payment.id === paymentMethod"
                  class="payment-method__selected-icon"></span>
          </li>
          <button class="sk-btn sk-btn--white payment-method__btn--add"
                  :class="{'payment-method__btn--add-first': paymentMethodsList.length}"
                  @click="openAddPaymentModal">{{ $gettext('Add new payment method') }}</button>
        </ul>
      </template>
      <template v-if="paymentMethodsList.length >= 7">
        <div class="payment-method__title-wrapper">
          <button v-if="isHelperVisible"
                  class="payment-method__help-icon"
                  @click="openPaymentMethodHelper"></button>
          <div v-if="!noDescription"
               class="payment-method__title">{{ paymentMethodDescription }}</div>
        </div>
        <div>
          <div v-if="!userCanChange && paymentMethodText"
               class="payment-method__select-wrapper">
            <div class="payment-method__select-text">{{ paymentMethodText }}</div>
            <button class="sk-link payment-method__link"
                    @click="userCanChange = true">{{ $gettext('Change') }}</button>
          </div>
          <div v-else
               class="payment-method__select-wrapper"
               @focusin="openPaymentMethodHelper">
            <sk-select :no-description="true"
                       :default-value="selectPaymentText"
                       :items-list="paymentMethodsList"
                       :preselected-value="paymentMethod"
                       class="payment-method__select"
                       @csvaluechanged="handleChangeMethod" />
            <button class="sk-select-btn payment-method__btn"
                    @click.prevent.stop="openAddPaymentModal"></button>
          </div>
        </div>
      </template>
    </div>
    <p v-if="paymentMethodErrors.length"
       class="payment-method__error text-error"
       :class="{'payment-method__error--center-align':paymentMethodsList.length <= 6}">{{ paymentMethodErrorText }}</p>
  </section>
</template>)

<script>
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
  import helpers from '@/helpers';

  export default {
    props: {
      noDescription: {
        type: Boolean
      },
      showAssignmentHelper: {
        type: Boolean,
      }
    },
    data() {
      return {
        userCanChange: false
      };
    },
    computed: {
      ...mapGetters({
        paymentMethods: 'PostingStore/PaymentMethodStore/currentPaymentMethods'
      }),
      ...mapGetters('OneAssignmentStore', ['jobId']),
      ...mapState('PostingStore/BookingRefStore', {
        fromBookingReference: ({fromBookingReference}) => fromBookingReference,
        fromPaymentBookingReference: ({fromPaymentBookingReference}) => fromPaymentBookingReference,
      }),
      ...mapState('PostingStore/PaymentMethodStore', {
        allPaymentMethods: (state) => state.allPaymentMethods || [],
        paymentMethod: (state) => state.paymentMethod || '',
        paymentMethodErrorName: (state) => state.errors.paymentMethod.name,
        paymentMethodErrors: (state) => state.errors.paymentMethod.errors
      }),
      ...mapState('PostingStore/DepartmentAttendersStore', {
        department: (state) => state.department || '',
        departmentsList: (state) => state.departmentsList || []
      }),
      ...mapState('PostAssignmentHelperStore', {
        isHelperVisible: ({isHelperVisible}) => isHelperVisible || false
      }),
      selectPaymentText() { return this.$gettext('Select payment method'); },
      paymentMethodDescription() { return this.$gettext('Send invoice to:'); },
      paymentMethodText() { return !this.userCanChange ? this.paymentMethodName : ''; },
      paymentMethodErrorText() { return this.paymentMethodErrors[0]; },
      paymentMethodName() {
        const paymentMethodData = this.paymentMethods.find((payment) => payment.id == this.paymentMethod);

        return helpers.getJobInfo.getPaymentMethodName(this, {
          paymentMethodData
        });
      },
      paymentMethodsList() {
        if (this.paymentMethods.length) {
          return this.paymentMethods.map((paymentMethodData) => {
            return {
              id: paymentMethodData.id,
              name: helpers.getJobInfo.getPaymentMethodName(this, {
                paymentMethodData
              })
            };
          });
        }
        return [];
      },
      paymentMethodsListCard() {
        if (this.paymentMethods.length) {
          return this.paymentMethods.filter((value) => !value.archived);
        }
        return [];
      },
      showDefaultCheckbox() {
        return this.allPaymentMethods.filter((paymentMethod) => paymentMethod.department_id === this.department).length > 0;
      }
    },
    methods: {
      ...mapActions('PostingStore/PaymentMethodStore', [
        'changePaymentMethod',
        'getPayments',
      ]),
      ...mapMutations('PostingStore/BookingRefStore', [
        'setFromBookingReference',
        'setFromPaymentBookingReference'
      ]),
      ...mapMutations('PostAssignmentHelperStore', [
        'openHelper',
        'setPopoverReference',
      ]),
      ...mapMutations('PostingStore/SubjectStore', ['setCategory']),
      openPaymentMethodHelper() {
        if (this.showAssignmentHelper) {
          this.setPopoverReference(this.$refs.paymentMethodRef);
          this.openHelper('paymentMethod');
        }
      },
      isOrganizationalMethod(payment) {
        return payment.methodType === 'organization';
      },
      handleChangeMethod(value) {
        this.setFromBookingReference('owner');
        this.setFromPaymentBookingReference('owner');
        this.changePaymentMethod(value);
        this.$store.dispatch('PostingStore/SubjectStore/getCategories', {paymentMethodId: value});
        if (!this.jobId) {
          this.setCategory('');
        }
      },
      handleAddingPaymentMethod(paymentData = {}) {
        this.getPayments();
        this.handleChangeMethod(paymentData.id);
      },
      openAddPaymentModal() {
        this.$store.commit('ModalStore/setModal', {
          component: 'payment-method-option',
          width: 510,
          classes: ['sk-modal--new'],
          data: {
            title: this.$gettext('Payment Methods'),
            context: this,
            successHandlingCallback: 'handleAddingPaymentMethod'
          }
        });
      },
      fullAddress(address) {
        return helpers.getFullAddress(address);
      }
    }
  };
</script>

<style scoped>
.payment-method {
  flex-wrap: nowrap;
  padding: 0 0 10px;
}

.payment-method__list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  width: 100%;
  list-style-type: none;
}

.payment-method__item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border: 2px solid transparent;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: var(--shadow-and-blur);
  cursor: pointer;
}

.payment-method__title-wrapper {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.payment-method__help-icon {
  width: 20px;
  height: 20px;
  background-image: var(--image-question-mark-icon-black);
  background-position: 50% 50%;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.payment-method__help-icon:focus {
  box-shadow: inset 0 0 0 2px #3af;
}

.payment-method__title {
  width: 160px;
  min-width: 160px;
  padding-right: 10px;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.14;
}

.payment-method__select-text {
  margin-right: 10px;
  font-size: 14px;
}

.payment-method__select {
  width: 100%;
  font-size: 13px;
}

.payment-method__select >>> .sk-select {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.payment-method__select-wrapper {
  display: flex;
  width: 100%;
}

.payment-method__item--active {
  border-color: var(--color-black);
}

.payment-method__link {
  margin: 0 0 0 auto;
}

.payment-method__name,
.payment-method__email,
.payment-method__address,
.payment-method__number {
  font-size: 14px;
  line-height: 1.43;
}

.payment-method__name,
.payment-method__email {
  color: var(--color-black);
  font-weight: bold;
}

.payment-method__number,
.payment-method__address {
  color: rgba(0, 0, 0, 0.5);
}

.payment-method__item--active .payment-method__name,
.payment-method__item--active .payment-method__email {
  color: var(--color-black);
}

.payment-method__selected-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: auto;
  width: 16px;
  height: 16px;
  background-image: url(~@assets/imgs/undefined_imgs/selected_payment_icon_black.svg);
}

.payment-method__btn.sk-select-btn {
  margin-top: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.payment-method__btn--add {
  max-width: 200px;
}

.payment-method__btn--add-first {
  margin-left: auto;
}

.payment-method__error {
  width: fit-content;
  margin-left: 160px;
  text-align: center;
}

.payment-method__error--center-align {
  width: auto;
  margin-left: 0;
}

@media (max-width: 767px) {
  .payment-method {
    flex-wrap: wrap;
  }

  .payment-method__list {
    display: block;
  }

  .payment-method__item:not(:first-child) {
    margin-top: 10px;
  }

  .payment-method__btn--add {
    margin-top: 10px;
    margin-left: 0;
  }

  .payment-method__help-icon {
    display: none;
  }
}

@media (max-width: 550px) {
  .payment-method__select-wrapper {
    max-width: 260px;
    margin-bottom: 0;
  }

  .payment-method__select {
    margin-left: 0;
  }

  .payment-method__error {
    width: auto;
    margin-left: 0;
  }
}
</style>
